// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ButtonSpinner_spinner__1EDuT","spin":"ButtonSpinner_spin__tDv-k"};